/**
 * Policy pages — plain structure for admin HTML
 */
(function () {
  'use strict';

  var rte = document.querySelector('.fabpad-policy__rte');
  if (!rte) return;

  rte.querySelectorAll('p').forEach(function (paragraph) {
    var bold = paragraph.querySelector('strong, b');
    if (!bold) return;

    var text = paragraph.textContent.replace(/\s+/g, ' ').trim();
    var boldText = bold.textContent.replace(/\s+/g, ' ').trim();
    if (text === boldText) {
      paragraph.classList.add('fabpad-policy__rte-heading');
    }
  });

  function isSectionHeading(el) {
    return el.matches('h2, h3, .fabpad-policy__rte-heading');
  }

  function headingText(el) {
    return el.textContent.replace(/\s+/g, ' ').trim();
  }

  function createSection(titleText) {
    var article = document.createElement('article');
    article.className = 'fabpad-policy__block';

    var head = document.createElement('header');
    head.className = 'fabpad-policy__block-head';

    var title = document.createElement('h2');
    title.className = 'fabpad-policy__block-title';
    title.textContent = titleText;

    head.appendChild(title);
    article.appendChild(head);
    return article;
  }

  function appendToSection(section, el) {
    if (el.matches('p, blockquote')) {
      el.classList.add('fabpad-policy__block-body');
      section.appendChild(el);
      return;
    }

    section.appendChild(el);
  }

  var children = Array.from(rte.children);
  var blocks = document.createElement('div');
  blocks.className = 'fabpad-policy__blocks';

  var currentSection = null;
  var preamble = document.createElement('div');
  preamble.className = 'fabpad-policy__preamble';
  var hasPreamble = false;

  children.forEach(function (el) {
    if (el.matches('h1')) {
      el.remove();
      return;
    }

    if (isSectionHeading(el)) {
      currentSection = createSection(headingText(el));
      blocks.appendChild(currentSection);
      return;
    }

    if (!currentSection) {
      if (el.matches('p')) {
        el.classList.add('fabpad-policy__block-body');
      }
      preamble.appendChild(el);
      hasPreamble = true;
      return;
    }

    appendToSection(currentSection, el);
  });

  rte.innerHTML = '';

  if (hasPreamble) {
    rte.appendChild(preamble);
  }

  if (blocks.childElementCount) {
    rte.appendChild(blocks);
  } else if (!hasPreamble) {
    rte.appendChild(blocks);
  }
})();
